module.exports = __webpack_public_path__ + "static/media/sx.c70e8d70.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sx.svg
// module id = 952
// module chunks = 0